<div class="breadcrumb-border hide-acc" *ngIf="isBreadCrumbAvailable">
  <div class="container-box">
    <div  *ngIf="isBreadCrumbAvailable">
      <div  *ngIf="!emailAlert">
      <ul class="breadcrumb rowHeading">
        <li *ngFor="let breadCrumb of breadCrumbs;let i = index">
          <span *ngIf="((breadCrumb['routerLink'] == '') || (breadCrumbs.length === (i+1)))">
        {{breadCrumb.label}}
      </span>
          <a *ngIf="((breadCrumb['routerLink'] !== '') && (breadCrumbs.length !== (i+1)))" routerLink="{{breadCrumb.routerLink}}" (click)="itemClick($event, breadCrumb,i)">{{breadCrumb.label}}</a>
        </li>
      </ul>
    </div>

      <div class="emailStatus row" *ngIf="emailAlert">
      <div class="col-sm-12 col-md-2">
          <ul class="breadcrumb">
            <li *ngFor="let breadCrumb of breadCrumbs;let i = index">
              <span *ngIf="((breadCrumb['routerLink'] == '') || (breadCrumbs.length === (i+1)))">
                {{breadCrumb.label}}
              </span>
              <a *ngIf="((breadCrumb['routerLink'] !== '') && (breadCrumbs.length !== (i+1)))" routerLink="{{breadCrumb.routerLink}}" (click)="itemClick($event, breadCrumb,i)">{{breadCrumb.label}}</a>
            </li>
          </ul>
        </div>
        <div class="alert valign-children-middle page-error" *ngIf="emailStatus=='false'">
          <div class="alert-error col-sm-12 col-md-6" role="img" aria-label="Error">
            <i class="icon-badgealert"></i>
          </div>
          <div>
            <h3>Something went wrong</h3>
            <p>We were unable to process your request to opt out. Please try again.</p>
          </div>
        </div>
        <div class="alert valign-children-middle" *ngIf="emailStatus=='true'">
          <div class="alert-success col-sm-12 col-md-6">
            <i class="icon-approval" role="img" aria-label="Success"></i>
          </div>
          <div>
          <h3>Success</h3>
          <p>You have successfully opted out of this reminder.</p>
        </div>
        </div>
      </div>


    </div>
  </div>
</div>
